import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import 'bootstrap-daterangepicker/daterangepicker.css';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { MultiSelect } from 'react-multi-select-component';
import moment from 'moment';
import Select from 'react-select';

import CheckboxTable from 'fragments/CheckboxTable';
import Button from 'react-bootstrap/Button';
import useToken from 'utils/UseToken';
import { useDispatch } from 'react-redux';
import { businessHandler, branchHandler } from '../../redux/handlers';
import * as reportHandler from '../../redux/handlers/report.handler';
import * as categoryHandler from '../../redux/handlers/productCategory.handler';

import ReactPaginate from 'react-paginate';

function formatNumber(number) {
  if (number === null || number === undefined || isNaN(number)) return '0';
  return Number(number).toLocaleString('th-TH');
}

function getCurrentDate(separator = '', dateb = new Date()) {
  let newDate = dateb;
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  return `${date}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${year}`;
}

function getCurrentDateM(separator = '') {
  let d = new Date();

  let newDate = new Date(d.setMonth(d.getMonth() - 1));
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  return `${date}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${year}`;
}

export function ReportProduct() {
  const { token } = useToken();
  let { businessSlug } = useParams();
  const dispatch = useDispatch();

  const [reportdata, setReportdata] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [searchdata, setSearchdata] = useState({
    branchID: '',
    startDate: getCurrentDateM('/'),
    endDate: getCurrentDate('/')
  });

  const [showResetSearch, setShowResetSearch] = useState(false);
  const [branchSelected, setBranchSelected] = useState([]);
  const [optionsBranch, setOptionsBranch] = useState([]);
  const [businessId, setBusinessId] = useState(null);
  const keyRef = useRef();
  const firstLoad = useRef(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterText, setFilterText] = useState('');
  const tableRef = useRef(null);

  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);

  const [columns, setColumns] = useState([]);

  const defaultColumns = [
    {
      name: (
        <div className="cheadpadding w-100 text-center">
          <div className="d-flex align-items-center" style={{ height: '42px' }}></div>
          <div className="py-3">รหัสสินค้า</div>
        </div>
      ),
      selector: row => row.code,
      width: '150px'
    },
    {
      name: (
        <div className="cheadpadding w-100">
          <div className="d-flex align-items-center" style={{ height: '42px' }}></div>
          <div className="py-3">รายการสินค้า</div>
        </div>
      ),
      selector: row => row.name,
      cell: (row, index, column, id) => (
        <div className="pimage">
          <img alt={`product-${index}`} src={row.image || ''} onError={handleImageError} />
          <div>
            <div style={{ fontWeight: 500, marginBottom: '5px' }}>{row.name}</div>
            <div style={{ fontSize: '12px', color: '#565DFF' }}>{row.code}</div>
          </div>
        </div>
      ),
      minWidth: '300px'
    },
    {
      name: (
        <div className="cheadpadding w-100">
          <div className="d-flex align-items-center" style={{ height: '42px' }}></div>
          <div className="py-3">หมวดหมู่</div>
        </div>
      ),
      selector: row => row.category_name,
      cell: (row, index, column, id) => (
        <div>
          <div className="text-xs text-black-100">{row.category_name || '-'}</div>
          <div className="text-base text-bold">{row.sub_category_name || '-'}</div>
        </div>
      ),
      width: '200px'
    }
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: '62px'
      }
    },
    headCells: {
      style: {
        paddingLeft: '15px',
        paddingRight: '15px',
        color: 'rgba(76, 78, 100, 0.87)',
        fontFamily: 'Sarabun',
        fontSize: '14px',
        background: '#F5F5F7',
        paddingTop: '5px',
        paddingBottom: '5px',
        fontWeight: '500'
      }
    },
    cells: {
      style: {
        paddingLeft: '15px',
        paddingRight: '15px',
        color: 'rgba(76, 78, 100, 0.87)',
        fontFamily: 'Sarabun',
        background: '#FFF',
        fontSize: '14px',
        fontWeight: '300',
        padding: '0'
      }
    },
    expanderRow: {
      style: {
        minHeight: '52px'
      }
    },
    pagination: {
      style: {
        borderBottomRightRadius: '0.75rem',
        borderBottomLeftRadius: '0.75rem'
      }
    }
  };

  const paginationComponentOptions = {
    rowsPerPageText: 'จำนวนรายการต่อหน้า',
    rangeSeparatorText: 'of',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'All'
  };

  useEffect(() => {
    const fetchCategories = async () => {
      if (businessSlug) {
        try {
          const result = await dispatch(categoryHandler.getAllProductCategories(businessSlug));
          if (result && Array.isArray(result)) {
            const formattedCategories = result.map(cat => ({
              value: cat.id,
              label: cat.name || cat.category_name
            }));
            setCategoryOptions(formattedCategories);
          }
        } catch (error) {
          console.error('Error fetching product categories:', error);
        }
      }
    };

    fetchCategories();
  }, [businessSlug, dispatch]);

  useEffect(() => {
    const fetchSubCategories = async () => {
      if (businessSlug && selectedCategory) {
        try {
          const result = await dispatch(
            categoryHandler.getAllProductSubCategoriesByMainCatId(businessSlug, selectedCategory.value)
          );

          if (result && Array.isArray(result)) {
            const formattedSubCategories = result.map(subCat => ({
              value: subCat.id,
              label: subCat.name || subCat.sub_category_name
            }));
            setSubCategoryOptions(formattedSubCategories);
          } else {
            setSubCategoryOptions([]);
          }
        } catch (error) {
          console.error('Error fetching product subcategories:', error);
          setSubCategoryOptions([]);
        }
      } else {
        setSubCategoryOptions([]);
      }
    };

    fetchSubCategories();
    setSelectedSubCategory(null);

    if (selectedCategory) {
      handleSearch();
    }
  }, [businessSlug, selectedCategory, dispatch]);

  useEffect(() => {
    if (selectedSubCategory) {
      handleSearch();
    }
  }, [selectedSubCategory]);

  const handleCategoryChange = selected => {
    setSelectedCategory(selected);
    if (!selected) {
      setSelectedSubCategory(null);
      handleSearch();
    }
  };

  const handleSubCategoryChange = selected => {
    setSelectedSubCategory(selected);
    handleSearch();
  };

  const setNewColumn = branchList => {
    if (branchList && branchList.length > 0) {
      let updatedColumns = [...defaultColumns];

      const totalSectionColumns = [
        {
          name: (
            <div className="cheadpadding w-100 text-center">
              <div
                className="total-header d-flex align-items-center justify-content-center"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '42px',
                  zIndex: 1,
                  textAlign: 'center',
                  width: '500px',
                  transform: 'translateX(0)'
                }}
                data-section-id="total"
              >
                รวมทุกสาขา
              </div>
              <div className="py-3 mt-[43px]">จำนวนที่ขายได้</div>
            </div>
          ),
          selector: row => row.quantity_sold,
          center: 'true',
          id: 'total-qty',
          width: '125px',
          cell: row => (
            <div className="total-section-cell w-full h-full flex justify-center items-center p-4">
              {formatNumber(row.quantity_sold)}
            </div>
          )
        },
        {
          name: (
            <div className="cheadpadding w-100 text-center">
              <div className="d-flex align-items-center" style={{ height: '42px', visibility: 'hidden' }}></div>
              <div className="py-3">ยอดขายสินค้าหลัก</div>
            </div>
          ),
          selector: row => row.sales,
          center: 'true',
          id: 'total-sale',
          width: '125px',
          cell: row => (
            <div className="total-section-cell w-full h-full flex justify-center items-center p-4">
              {formatNumber(row.sales)}
            </div>
          )
        },
        {
          name: (
            <div className="cheadpadding w-100 text-center">
              <div className="d-flex align-items-center" style={{ height: '42px', visibility: 'hidden' }}></div>
              <div className="py-3">ยอดขายตัวเลือก</div>
            </div>
          ),
          selector: row => row.sales_option,
          center: 'true',
          id: 'total-option',
          width: '125px',
          cell: row => (
            <div className="total-section-cell w-full h-full flex justify-center items-center p-4">
              {formatNumber(row.sales_option)}
            </div>
          )
        },
        {
          name: (
            <div className="cheadpadding w-100 text-center">
              <div className="d-flex align-items-center" style={{ height: '42px', visibility: 'hidden' }}></div>
              <div className="py-3">ยอดขายรวม</div>
            </div>
          ),
          selector: row => row.sales_total,
          center: 'true',
          id: 'total-total',
          width: '125px',
          cell: row => (
            <div className="total-section-cell total-value w-full h-full flex justify-center items-center p-4">
              {formatNumber(row.sales_total)}
            </div>
          )
        }
      ];

      updatedColumns = [...updatedColumns, ...totalSectionColumns];

      branchList.forEach((branch, index) => {
        const isEven = index % 2 === 0;
        const branchHeaderClass = isEven ? 'branch-section-even' : 'branch-section-odd';
        const branchCellClass = isEven ? 'branch-cell-even' : 'branch-cell-odd';

        const firstBranchColumn = {
          name: (
            <div className="cheadpadding w-100 text-center">
              <div
                className={`branch-header d-flex align-items-center justify-content-center ${branchHeaderClass}`}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '42px',
                  zIndex: 1,
                  textAlign: 'center',
                  width: '500px',
                  transform: 'translateX(0)'
                }}
                data-branch-id={branch.branch_id}
              >
                {branch.branch_name}
              </div>
              <div className="py-3 mt-[43px]">จำนวนที่ขายได้</div>
            </div>
          ),
          selector: row => {
            const branchData = row.branch.find(b => parseInt(b.branch_id) === parseInt(branch.branch_id));
            return branchData ? branchData.total_quantity : '0';
          },
          center: 'true',
          id: `branch-${branch.branch_id}-qty`,
          width: '125px',
          cell: row => {
            const branchData = row.branch.find(b => parseInt(b.branch_id) === parseInt(branch.branch_id));
            return (
              <div className={`${branchCellClass} w-full h-full flex justify-center items-center p-4`}>
                {formatNumber(branchData ? branchData.total_quantity : '0')}
              </div>
            );
          }
        };

        const otherBranchColumns = [
          {
            name: (
              <div className="cheadpadding w-100 text-center">
                <div className="d-flex align-items-center" style={{ height: '42px', visibility: 'hidden' }}></div>
                <div className="py-3">ยอดขายสินค้าหลัก</div>
              </div>
            ),
            selector: row => {
              const branchData = row.branch.find(b => parseInt(b.branch_id) === parseInt(branch.branch_id));
              return (branchData && branchData.sale_price) || 0;
            },
            center: 'true',
            id: `branch-${branch.branch_id}-sale`,
            width: '125px',
            cell: row => {
              const branchData = row.branch.find(b => parseInt(b.branch_id) === parseInt(branch.branch_id));
              return (
                <div className={`${branchCellClass} w-full h-full flex justify-center items-center p-4`}>
                  {formatNumber((branchData && branchData.sale_price) || 0)}
                </div>
              );
            }
          },
          {
            name: (
              <div className="cheadpadding w-100 text-center">
                <div className="d-flex align-items-center" style={{ height: '42px', visibility: 'hidden' }}></div>
                <div className="py-3">ยอดขายตัวเลือก</div>
              </div>
            ),
            selector: row => {
              const branchData = row.branch.find(b => parseInt(b.branch_id) === parseInt(branch.branch_id));
              return (branchData && branchData.option_price) || 0;
            },
            center: 'true',
            id: `branch-${branch.branch_id}-option`,
            width: '125px',
            cell: row => {
              const branchData = row.branch.find(b => parseInt(b.branch_id) === parseInt(branch.branch_id));
              return (
                <div className={`${branchCellClass} w-full h-full flex justify-center items-center p-4`}>
                  {formatNumber((branchData && branchData.option_price) || 0)}
                </div>
              );
            }
          },
          {
            name: (
              <div className="cheadpadding w-100 text-center">
                <div className="d-flex align-items-center" style={{ height: '42px', visibility: 'hidden' }}></div>
                <div className="py-3">ยอดขายรวม</div>
              </div>
            ),
            selector: row => {
              const branchData = row.branch.find(b => parseInt(b.branch_id) === parseInt(branch.branch_id));
              return (branchData && branchData.total_price) || 0;
            },
            center: 'true',
            id: `branch-${branch.branch_id}-total`,
            width: '125px',
            cell: row => {
              const branchData = row.branch.find(b => parseInt(b.branch_id) === parseInt(branch.branch_id));
              return (
                <div className={`${branchCellClass} total-value w-full h-full flex justify-center items-center p-4`}>
                  {formatNumber((branchData && branchData.total_price) || 0)}
                </div>
              );
            }
          }
        ];

        updatedColumns.push(firstBranchColumn, ...otherBranchColumns);
      });

      setColumns(updatedColumns);
    } else {
      setColumns([
        ...defaultColumns,
        {
          name: (
            <div className="cheadpadding w-100 text-center">
              <div
                className="total-header d-flex align-items-center justify-content-center"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '42px',
                  zIndex: 1,
                  textAlign: 'center',
                  width: '500px',
                  transform: 'translateX(0)'
                }}
                data-section-id="total"
              >
                รวมทุกสาขา
              </div>
              <div className="py-3 mt-[43px]">จำนวนที่ขายได้</div>
            </div>
          ),
          selector: row => row.quantity_sold,
          center: 'true',
          id: 'total-qty',
          width: '125px',
          cell: row => (
            <div className="total-section-cell w-full h-full flex justify-center items-center p-4">
              {formatNumber(row.quantity_sold)}
            </div>
          )
        },
        {
          name: (
            <div className="cheadpadding w-100 text-center">
              <div className="d-flex align-items-center" style={{ height: '42px', visibility: 'hidden' }}></div>
              <div className="py-3">ยอดขายสินค้าหลัก</div>
            </div>
          ),
          selector: row => row.sales,
          center: 'true',
          id: 'total-sale',
          width: '125px',
          cell: row => (
            <div className="total-section-cell w-full h-full flex justify-center items-center p-4">
              {formatNumber(row.sales)}
            </div>
          )
        },
        {
          name: (
            <div className="cheadpadding w-100 text-center">
              <div className="d-flex align-items-center" style={{ height: '42px', visibility: 'hidden' }}></div>
              <div className="py-3">ยอดขายตัวเลือก</div>
            </div>
          ),
          selector: row => row.sales_option,
          center: 'true',
          id: 'total-option',
          width: '125px',
          cell: row => (
            <div className="total-section-cell w-full h-full flex justify-center items-center p-4">
              {formatNumber(row.sales_option)}
            </div>
          )
        },
        {
          name: (
            <div className="cheadpadding w-100 text-center">
              <div className="d-flex align-items-center" style={{ height: '42px', visibility: 'hidden' }}></div>
              <div className="py-3">ยอดขายรวม</div>
            </div>
          ),
          selector: row => row.sales_total,
          center: 'true',
          id: 'total-total',
          cell: row => (
            <div className="total-section-cell total-value w-full h-full flex justify-center items-center p-4">
              {formatNumber(row.sales_total)}
            </div>
          ),
          width: '125px'
        }
      ]);
    }
  };

  useEffect(() => {
    if (showResetSearch) {
      setTimeout(() => {
        const tableElement = document.querySelector('.data-custom-header');
        if (!tableElement) return;

        const totalHeader = tableElement.querySelector('[data-section-id="total"]');
        if (totalHeader) {
          const headerCell = totalHeader.closest('div[role="columnheader"]');
          if (headerCell) {
            const headerWidth = 4 * 125;
            totalHeader.style.width = `${headerWidth}px`;
          }
        }

        if (branchList.length > 0) {
          branchList.forEach((branch, index) => {
            const branchHeader = tableElement.querySelector(`[data-branch-id="${branch.branch_id}"]`);
            if (!branchHeader) return;

            const headerCell = branchHeader.closest('div[role="columnheader"]');
            if (!headerCell) return;

            const headerWidth = 4 * 125;
            branchHeader.style.width = `${headerWidth}px`;
          });
        }
      }, 100);
    }
  }, [columns, showResetSearch, branchList]);

  const formatReportData = apiResponse => {
    if (!apiResponse || apiResponse.length === 0) {
      return [];
    }

    return apiResponse.map(item => {
      return {
        code: item.product_sku || '-',
        name: item.product_name || '-',
        image: item.product_image_path || '',
        barcode: item.product_barcode || '-',
        quantity_sold: item.total_quantity || 0,
        sales: item.sale_price || 0,
        sales_option: item.option_price || 0,
        sales_total: item.total_price || 0,
        branch: item.branch || [],
        category_name: item.product_category || '-',
        sub_category_name: item.product_sub_category || '-'
      };
    });
  };

  const formatBranchList = apiResponse => {
    if (!apiResponse || apiResponse.length === 0) {
      return [];
    }

    const branchesMap = new Map();

    apiResponse.forEach(product => {
      if (product.branch && Array.isArray(product.branch)) {
        product.branch.forEach(branch => {
          if (branch.branch_id && !branchesMap.has(branch.branch_id)) {
            branchesMap.set(branch.branch_id, {
              branch_id: branch.branch_id,
              branch_name: branch.branch_name || `Branch ${branch.branch_id}`
            });
          }
        });
      }
    });

    const branchList = Array.from(branchesMap.values());

    return branchList;
  };

  const handleSearch = async () => {
    try {
      if (firstLoad.current === true) {
        firstLoad.current = false;
      }

      const apiStartDate = searchdata.startDate.split('/').reverse().join('-');
      const apiEndDate = searchdata.endDate.split('/').reverse().join('-');

      const params = {
        startDate: apiStartDate,
        endDate: apiEndDate
      };

      if (branchSelected && branchSelected.length > 0) {
        params.branchId = branchSelected.map(branch => branch.value);
      }

      if (selectedCategory && selectedCategory.value) {
        params.productCategoryId = selectedCategory.value;
      }

      if (selectedSubCategory && selectedSubCategory.value) {
        params.productSubCategoryId = selectedSubCategory.value;
      }

      const response = await dispatch(reportHandler.getSalesProductReport(businessSlug, params));

      if (response) {
        const formattedData = formatReportData(response);
        const branchListData = formatBranchList(response);

        setBranchList(branchListData);
        setNewColumn(branchListData);
        setReportdata(formattedData);
        setShowResetSearch(true);
        setCurrentPage(1);
      } else {
        console.error('Invalid response format:', response);
        setReportdata([]);
        setBranchList([]);
      }
    } catch (err) {
      console.error('Error fetching report data:', err);
      setReportdata([]);
      setBranchList([]);
    }
  };

  const resetFilter = () => {
    setShowResetSearch(false);
    setReportdata([]);
    setBranchList([]);
    setBranchSelected([]);
    setColumns(defaultColumns);
    setRowsPerPage(10);
    setCurrentPage(1);
    setFilterText('');
    setSelectedCategory(null);
    setSelectedSubCategory(null);
    setSearchdata({
      branchID: '',
      startDate: getCurrentDateM('/'),
      endDate: getCurrentDate('/')
    });
  };

  const formatBranch = rawData => {
    let updateBranch = rawData
      ?.filter(e => e.is_status)
      .map(item => ({
        value: item.id,
        label: item.branch_name || item.name
      }));
    return updateBranch;
  };

  const updateBranchChanges = selectedBranches => {
    setBranchSelected(selectedBranches);
  };

  const handleApply = (event, picker) => {
    setSearchdata(prev => ({
      ...prev,
      startDate: picker.startDate.format('DD/MM/YYYY'),
      endDate: picker.endDate.format('DD/MM/YYYY')
    }));
  };

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const handleImageError = e => {
    e.target.onerror = null;
    e.target.src = '/images/img-default.jpeg';
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1);

    setTimeout(() => {
      const event = new Event('resize');
      window.dispatchEvent(event);
    }, 100);
  };

  useEffect(() => {
    const initializeComponent = async () => {
      try {
        const businessData = await dispatch(businessHandler.getBusinessBySlug(businessSlug));

        if (businessData && businessData.business && businessData.business.id) {
          setBusinessId(businessData.business.id);
        } else {
          console.error('Could not get business ID from response');
        }
      } catch (error) {
        console.error('Error initializing component:', error);
      }
    };

    initializeComponent();
  }, [businessSlug, dispatch]);

  useEffect(() => {
    const fetchBranches = async () => {
      if (!businessId) {
        return;
      }

      try {
        const data = await dispatch(businessHandler.getBusinessListBranch(businessId));

        if (data && data.business && data.business.branch) {
          const formattedBranches = formatBranch(data.business.branch);
          setOptionsBranch(formattedBranches);
        } else {
          console.warn('No branch data in response');
          setOptionsBranch([]);
        }
      } catch (error) {
        console.error('Error fetching branches:', error);
      }
    };

    fetchBranches();
  }, [businessId, dispatch]);

  const filteredItems = reportdata.filter(item => {
    if (!filterText) return true;

    return (
      (item.code && item.code.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.category_name && item.category_name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.sub_category_name && item.sub_category_name.toLowerCase().includes(filterText.toLowerCase()))
    );
  });

  const getPaginatedData = () => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return filteredItems.slice(startIndex, endIndex);
  };

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      /* Base styles for table header */
      .data-custom-header .rdt_TableHead {
        position: relative;
        z-index: 1;
      }
      
      /* Header border styles */
      .branch-header:not(:last-child) {
        border-right: 1px solid white;
      }

      /* Total section header */
      .total-header {
        width: 500px !important;
        background-color: #565DFF !important;
        color: #FFF !important;
      }
      
      /* Total section cells */
      .total-section-cell {
        background-color: #e8e9ff !important;
        color: #565DFF !important;
        width: 100% !important;
        height: 100% !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        padding: 15px !important;
      }
      
      .total-section-cell.total-value {
        font-weight: 700 !important;
      }
      
      /* Dynamic branch styles - generated programmatically */
      .branch-section-even {
        background-color: #2DC76D !important;
        color: #FFF !important;
      }
      
      .branch-section-odd {
        background-color: #F5F5F7 !important;
        color: rgba(76, 78, 100, 0.87) !important;
      }
      
      .branch-cell-even {
        background-color: #e3f9ee !important;
        color: #2DC76D !important;
        width: 100% !important;
        height: 100% !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        padding: 15px !important;
      }
      
      .branch-cell-odd {
        background-color: #f9f9f9 !important;
        color: rgba(76, 78, 100, 0.87) !important;
        width: 100% !important;
        height: 100% !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        padding: 15px !important;
      }
      
      .branch-cell-even.total-value, .branch-cell-odd.total-value {
        font-weight: 700 !important;
      }

      /* Category select styling */
      .category-select {
        min-width: 180px;
        margin-right: 10px;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div>
      <nav aria-label="breadcrumb" className="mt-2">
        <ol className="breadcrumb fs-16 ps-0">
          <li className="breadcrumb-item ">
            <a href="#" className="tc-7  text-decoration-none">
              รายงาน
            </a>
          </li>
          <li className="breadcrumb-item active tc-1 " aria-current="page">
            {' '}
            ยอดขายรายสินค้า{' '}
          </li>
        </ol>
      </nav>

      <div className="card card-st-2 mb-4">
        <div className="card-body  py-4">
          <div className="fw-bold mb-3">ค้นหาขั้นสูง</div>
          <div className="row items-center">
            <div className="col-xl-3 col-lg-3 col-3">
              <MultiSelect
                options={optionsBranch}
                className={`w-100 select-st-1 pd`}
                value={branchSelected}
                onChange={e => updateBranchChanges(e)}
                labelledBy="Select"
                overrideStrings={{
                  selectAll: 'ทั้งหมด',
                  allItemsAreSelected: 'ทั้งหมด',
                  selectSomeItems: 'เลือกสาขา...'
                }}
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-3">
              <DateRangePicker
                initialSettings={{
                  startDate: searchdata.startDate,
                  endDate: searchdata.endDate,
                  locale: {
                    format: 'DD/MM/YYYY'
                  }
                }}
                onApply={handleApply}
              >
                <input type="text" className="form-control iconcalendar-right" />
              </DateRangePicker>
            </div>
            <div className="col-auto">
              <Button
                type="button"
                className="btn-st-3 flex justify-center items-center"
                style={{ width: '120px', height: '40px' }}
                onClick={handleSearch}
              >
                ค้นหา
              </Button>
            </div>
            {showResetSearch && (
              <div className="col-auto">
                <Button
                  type="button"
                  className="bg-orange-400 flex justify-center items-center hover:bg-orange-300"
                  style={{ width: '150px', height: '40px', border: 0 }}
                  onClick={resetFilter}
                >
                  ล้างการค้นหา
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>

      {showResetSearch && (
        <div className="card card-st-2">
          <div className="card-body p-0 rounded-xl">
            <div className="d-flex align-items-center px-4 mb-4 pt-4 rd-0">
              <div className="d-flex align-items-center me-auto">
                <Button
                  type="button"
                  className="btn btn-export-st-1"
                  style={{ marginRight: '8px' }}
                  onClick={() =>
                    dispatch(
                      reportHandler.exportSalesProductReport(businessSlug, {
                        startDate: searchdata.startDate.split('/').reverse().join('-'),
                        endDate: searchdata.endDate.split('/').reverse().join('-'),
                        ...(branchSelected &&
                          branchSelected.length > 0 && {
                            branchId: branchSelected.map(branch => branch.value)
                          }),
                        ...(selectedCategory && { productCategoryId: selectedCategory.value }),
                        ...(selectedSubCategory && { productSubCategoryId: selectedSubCategory.value })
                      })
                    )
                  }
                >
                  <i className="icon-download me-2"></i> Export
                </Button>

                {/* Add category filters next to Excel button */}
                <div className="d-flex align-items-center">
                  <div className="category-select">
                    <Select
                      name="tableCategory"
                      onChange={handleCategoryChange}
                      className="select-st-1 sm"
                      options={categoryOptions}
                      placeholder="เลือกหมวดหมู่หลัก"
                      isClearable={true}
                      value={selectedCategory}
                    />
                  </div>

                  <div className="category-select">
                    <Select
                      name="tableSubCategory"
                      onChange={handleSubCategoryChange}
                      className="select-st-1 sm"
                      options={subCategoryOptions}
                      placeholder="เลือกหมวดหมู่ย่อย"
                      isDisabled={!selectedCategory}
                      isClearable={true}
                      value={selectedSubCategory}
                    />
                  </div>
                </div>
              </div>

              <div>
                <input
                  type="text"
                  className="form-control form-st-4"
                  placeholder="ค้นหา"
                  value={filterText}
                  onChange={e => setFilterText(e.target.value)}
                />
              </div>
            </div>
            <div ref={tableRef} className="position-relative">
              <DataTable
                columns={columns}
                data={getPaginatedData()}
                customStyles={customStyles}
                selectableRows
                selectableRowsComponent={CheckboxTable}
                className="data-custom-header"
                pagination
                paginationServer
                paginationTotalRows={filteredItems.length}
                paginationRowsPerPageOptions={[5, 10, 25, 50, 100]}
                paginationPerPage={rowsPerPage}
                paginationDefaultPage={currentPage}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                paginationComponentOptions={paginationComponentOptions}
                paginationComponent={props => (
                  <CustomPagination
                    rowCount={filteredItems.length}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                  />
                )}
                noDataComponent={<div className="p-4 text-center">ไม่พบข้อมูล</div>}
              />
            </div>
            <div className="py-3"></div>
          </div>
        </div>
      )}
    </div>
  );
}

const CustomPagination = ({ rowsPerPage, rowCount, currentPage, onChangePage, onChangeRowsPerPage }) => {
  const count = Math.ceil(rowCount / rowsPerPage);
  const pageSizeOptions = [5, 10, 25, 50, 100];

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-end mx-0 pt-3"
        style={{ borderTop: '1px solid #e0e0e0' }}
      >
        <div className="fs-12 d-flex justify-content-start me-5" style={{ color: '#4C4E64' }}>
          <p>
            <span className="me-2">จำนวนรายการต่อหน้า</span>
            <select
              className="form-select form-select-sm d-inline-block me-4"
              style={{ width: 'auto', minWidth: '70px' }}
              value={rowsPerPage}
              onChange={e => {
                onChangeRowsPerPage(Number(e.target.value), 1);
              }}
            >
              {pageSizeOptions.map(option => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {rowCount === 0
              ? 0
              : formatNumber(
                  currentPage * rowsPerPage + 1 - rowsPerPage > rowCount
                    ? rowCount
                    : currentPage * rowsPerPage + 1 - rowsPerPage
                )}
            <span className="mx-1 fs-18">-</span>
            {formatNumber(currentPage * rowsPerPage > rowCount ? rowCount : currentPage * rowsPerPage)}
            <span className="mx-1">of</span> {formatNumber(rowCount)}
          </p>
        </div>

        <div className="d-flex justify-content-end">
          <ReactPaginate
            previousLabel={<i className="icon-prev"></i>}
            nextLabel={<i className="icon-next"></i>}
            forcePage={currentPage !== 0 ? currentPage - 1 : 0}
            onPageChange={page => {
              onChangePage(page.selected + 1);
            }}
            pageCount={count || 1}
            breakLabel={'...'}
            pageRangeDisplayed={2}
            marginPagesDisplayed={2}
            activeClassName={'active'}
            pageClassName={'page-item'}
            nextLinkClassName={'page-link'}
            nextClassName={'page-item next'}
            previousClassName={'page-item prev'}
            previousLinkClassName={'page-link'}
            pageLinkClassName={'page-link'}
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName={'pagination react-paginate pagination-sm justify-content-end pr-1 mt-1'}
            disabledClassName={'disabled'}
          />
        </div>
      </div>
    </>
  );
};

export default ReportProduct;
